import { $api } from "@/shared/api";
import { useConnectionState } from "@/shared/realtime";

import { isClipWorking } from "../model/clipState";
import { HIGHLIGHTS_POLL_INTERVAL_MS } from "./HIGHLIGHTS_POLL_INTERVAL_MS";
import { useHighlightsAllowed } from "./useHighlightsAllowed";

// Хайлайты разбора (`GET /api/highlights/analyses/{id}`): блок «Лучшее в матче». Моменты
// ещё ищутся или клип в работе, а соединения нет — перечитываем сами. Хайлайты закрыты для
// игрока — запроса нет.
export const useAnalysisHighlights = (analysisId: number) => {
  const connection = useConnectionState();
  const allowed = useHighlightsAllowed();
  return $api.useQuery(
    "get",
    "/api/highlights/analyses/{analysis_id}",
    { params: { path: { analysis_id: analysisId } } },
    {
      enabled: allowed,
      refetchInterval: ({ state }) => {
        const data = state.data;
        if (connection === "connected" || data === undefined) {
          return false;
        }
        return data.status === "pending" || data.items.some(isClipWorking)
          ? HIGHLIGHTS_POLL_INTERVAL_MS
          : false;
      },
    },
  );
};
